import React from 'react'
import onlyNotLogged from 'app/components/HOCs/onlyNotLogged'

export default onlyNotLogged()(() => <div>Signup page</div>)
